import MedicineRepository from '@/js/repositories/MedicineRepository'
import store from '@/js/store'
import moment from 'moment'
moment.suppressDeprecationWarnings = true

function storeMedicines(payload, res, id) {
	if (payload.params.from_date == payload.params.to_date) {
		sessionStorage.setItem('medicine_one_day_' + id, JSON.stringify({
			createdTime: Date.now(),
			medicines: res,
		}))
	} else {
		sessionStorage.setItem('medicines_' + id, JSON.stringify({
			createdTime: Date.now(),
			medicines: res,
		}))
	}
}

const state = {
	medicines: []
}

const getters = {

}

const actions = {
	async getMedicines({ commit }, payload) {
		let childId = payload.params.childId ? payload.params.childId : store.state.otp.childId
		let dataSession = null
		let removeData = false
		const timeAllowExistence = 600000
		if (payload.params.from_date == payload.params.to_date) {
			dataSession = JSON.parse(sessionStorage.getItem('medicine_one_day_' + childId)) || null
			if (Date.now() - dataSession?.createdTime > timeAllowExistence) {
				sessionStorage.removeItem('medicine_one_day_' + childId)
				removeData = true
			}
		} else {
			dataSession = JSON.parse(sessionStorage.getItem('medicines_' + childId)) || null
			if (Date.now() - dataSession?.createdTime > timeAllowExistence) {
				sessionStorage.removeItem('medicines_' + childId)
				removeData = true
			}
		}
		if(dataSession && !removeData) {
			commit('MEDICINE_INFO', dataSession.medicines)
		}
		else {
			await MedicineRepository.getMedicines(payload)
				.then(res => {
					storeMedicines(payload, res.data.data, childId)
					commit('MEDICINE_INFO', JSON.parse(JSON.stringify(res.data.data)))
				})
				.catch(error => {
					sessionStorage.removeItem('medicines_' + childId)
					sessionStorage.removeItem('medicine_one_day_' + childId)
					commit('MEDICINE_INFO', '')
				})
		}
	}
}

const mutations = {
  	MEDICINE_INFO(state, data) {
		state.medicines = data
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
